// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__puaw3","label":"styles_label__MBinn","description":"styles_description__tCQEM","input":"styles_input__SbQTG","error":"styles_error__A0T6j"};